import { render, staticRenderFns } from "./StandardTable.vue?vue&type=template&id=68836d3f&scoped=true"
import script from "./StandardTable.vue?vue&type=script&lang=js"
export * from "./StandardTable.vue?vue&type=script&lang=js"
import style0 from "./StandardTable.vue?vue&type=style&index=0&id=68836d3f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68836d3f",
  null
  
)

export default component.exports